import React, { useState, useEffect } from "react";
import { FaCheck, FaTimes } from "react-icons/fa";
import "./SortModal.css";

const SortModal = ({
  isOpen,
  onClose,
  onApply,
  currentColumn,
  currentOrder,
  columns = [],
}) => {
  const [column, setColumn] = useState("");
  const [order, setOrder] = useState("asc");

  useEffect(() => {
    if (currentColumn) setColumn(currentColumn);
    if (currentOrder) setOrder(currentOrder);
  }, [currentColumn, currentOrder]);

  if (!isOpen) return null;

  const handleSelect = (selectedColumn) => {
    if (column === selectedColumn) {
      setOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setColumn(selectedColumn);
      setOrder("asc");
    }
  };

  const handleApply = () => {
    onApply(column, order);
    onClose();
  };

  return (
    <div className="overlay-sort" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h3>Sort by</h3>

        {columns.map((item) => (
          <div
            key={item.value}
            className={`option ${
              column === item.value ? "active" : ""
            }`}
            onClick={() => handleSelect(item.value)}
          >
            <input
              type="radio"
              checked={column === item.value}
              readOnly
            />

            {/* 👇 Show Label instead of DB column */}
            <span>{item.label}</span>

            {column === item.value && (
              <span className="order">
                {order === "asc"
                  ? "Ascending ↑"
                  : "Descending ↓"}
              </span>
            )}
          </div>
        ))}

        <div className="footer">
          <button className="apply" onClick={onClose}><FaTimes /></button>
          <button className="apply" onClick={handleApply}>
            <FaCheck />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SortModal;